<!-- eslint-disable -->
<template lang="pug">
    .list
        .list__content
            .list__header
                slot(name="header")
                .header__buttons(v-if="$slots['excel'] || $slots['button']")
                    slot(name="excel")
                    slot(name="button")
            .list__fields(v-if="$slots['fields']")
                slot(name="fields")
            divider(v-if="displayDivider" :margin="'0 0 16px'")
            .list__body
                slot(name='preview')
            .list__button(v-if="$slots['run']")
                slot(name='run')
</template>

<script>
    /*eslint-disable*/
    export default {
        computed: {
            displayDivider () {
                return ['homework:list', 'homework-template:list', 'support', 'conversations', 'messages'].includes(this.$route.name)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .empty {
        font-size: 22px;
        line-height: 22px;
        text-align: center;
        color: #2187FF;
        margin-top: 3rem;
    }
    .empty__button-block {
        margin-top: 15px;
    }
    .list {
        margin: 0;
        padding: 0;
        height: 100%;
        background-color: $x-color-white;
        box-sizing: border-box;
        font-weight: normal;
        @include media($sm) {
            padding: 30px;
            border-radius: $border-radius-40;
        }
        @media screen and (max-width: 568px) {
            border-radius: 0;
        }
    }

    .list__content {
        margin: 0;
        padding: 20px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        box-sizing: border-box;
        border-radius: $border-radius-20;
        @include media($md) {
            padding: 30px;
        }
    }

    .list__header {
        padding: 15px 0;
        display: flex;
        flex-direction: column;

        font-weight: 500;
        font-size: 22px;
        line-height: 26px;

        @include media($lg) {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }
    }

    .list__fields {
        padding: 0;
        margin: 15px 0 40px 0;
        @include media($xlg) {
            margin: 30px 0 25px 0;
            width: 100%;
        }
    }

    .header__buttons {
        margin: 12px 0 0 0;
        min-width: fit-content;
        display: flex;
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
        }
        @include media($lg) {
            margin: 0 0 0 30px;
            flex-direction: row;
        }
    }
</style>
